import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import orderService from '../../services/order';

const initialState = {
  loading: false,
  list: [],
  error: '',
  params: { page: 1, perPage: 10 },
  meta: {},
};

export const fetchTrackingOrders = createAsyncThunk(
  'tracking/fetchTrackingOrders',
  (params = {}) =>
    orderService
      .getTrackingPaginate({ ...initialState.params, ...params })
      .then((res) => res)
);

const trackingSlice = createSlice({
  name: 'tracking',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrackingOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTrackingOrders.fulfilled, (state, action) => {
        const payload = action.payload;
        const backend = payload?.data ?? payload;
        const list = Array.isArray(backend?.data) ? backend.data : (Array.isArray(backend) ? backend : []);
        const rawMeta = payload?.pagination ?? payload?.meta ?? backend?.meta ?? {};
        const meta = {
          current_page: rawMeta.current_page ?? rawMeta.page,
          per_page: rawMeta.per_page ?? rawMeta.perPage,
          total: rawMeta.total,
          lastPage: rawMeta.lastPage,
        };
        state.loading = false;
        state.list = list ?? [];
        state.meta = meta;
        state.params.page = meta.current_page ?? state.params.page;
        state.params.perPage = meta.per_page ?? state.params.perPage;
        state.error = '';
        if (process.env.NODE_ENV === 'development') {
          console.log('[tracking] fetchTrackingOrders response', { payloadData: payload?.data, listLength: list?.length, firstItem: list?.[0] });
        }
      })
      .addCase(fetchTrackingOrders.rejected, (state, action) => {
        state.loading = false;
        state.list = [];
        state.error = action.error?.message ?? '';
      });
  },
});

export default trackingSlice.reducer;
